import PubSub from "pubsub-js";
import { pubsubEvents } from "../../components/helpers/socket/pubsubEvent";

/**
 * Handles alert status notifications from the server.
 * Tracks the multi-step initialization process (marketdata_subscription, query_deployment).
 */
export function alerting_status_messageReceived(data) {
  if (data.service === "alerting" && data.action === "status") {
    console.log("🔔 Alert Status Notification Received:", data);

    let payload = {};
    if (data.payload) {
      try {
        payload =
          typeof data.payload === "string"
            ? JSON.parse(data.payload)
            : data.payload;
      } catch (e) {
        console.error("Failed to parse alert status payload", e);
        return;
      }
    } else if (data.errors && data.errors.length > 0) {
      const errorStr = data.errors[0];
      let extractedMessage = errorStr;
      try {
        const jsonMatch =
          typeof errorStr === "string" ? errorStr.match(/({.*})/) : null;
        if (jsonMatch && jsonMatch[0]) {
          const parsedInner = JSON.parse(jsonMatch[0]);
          if (parsedInner?.message) extractedMessage = parsedInner.message;
          else if (parsedInner?.error) extractedMessage = parsedInner.error;
        }
      } catch (e) {
        console.warn("Failed to parse nested error JSON:", e);
      }
      payload = {
        status: data.status || "ERROR",
        message: extractedMessage,
      };
    }

    console.log("🔔 Alert Status Notification Payload:", payload);

    // Publish the status update.
    // Components can track reqId to see if both required types are received.
    PubSub.publish(pubsubEvents.stompSubscriptionKeys.ALERTING_STATUS_UPDATE, {
      reqId: data.requestID,
      type: payload?.type, // e.g., marketdata_subscription, query_deployment
      status: payload?.status || data.status, // e.g., success, failure
      reason: payload?.reason,
      message: payload?.message,
    });
  }
}
